import "@/styles/index.css";

import form from "@/scripts/components/form/form";
import mediaSlider from "@/scripts/components/media-slider";
import modal from "@/scripts/components/modal";
import scrollReveal from "@/scripts/components/scroll-reveal";
import scrollTo from "@/scripts/components/scroll-to";
import siteHeader from "@/scripts/components/site-header";
import slideToggle from "@/scripts/components/slide-toggle";

form.init();
mediaSlider.init();
modal.init();
scrollReveal.init();
scrollTo.init();
siteHeader.init();
slideToggle.init();

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document.documentElement.classList.remove("_preload");
  }, 250);
});
